<template>
  <div class="vm-system">

    <banner :bannerList="bannerList"></banner>
    <nav-right></nav-right>

    <!-- JAva项目 -->
    <jave-one></jave-one>

    <!-- JAva项目 -->
    <socia></socia>

    <!-- 中级软件工程师 -->
    <intermediate-one class="bgf5"></intermediate-one>

    <!-- 中级软件工程师 -->
    <intermediate></intermediate>
    <!-- 课程特色 -->
    <characteristic></characteristic>
    <!-- 课程亮点 -->
    <spot></spot>
    <!-- 试听课 -->
    <audition></audition>
    <!-- 高薪保障 -->
    <guarantee />
    <!-- 高薪英雄 -->
    <div class="vm-title bgf5" >
      <p class="vm-title-chines">高薪榜样</p>
      <div class="vm-title-line"></div>
      <p class="vm-title-english">今天他们的收获就是未来你的榜样</p>
    </div>
    <salary-hero :salaryList="salaryHero" class="bgf5"></salary-hero>
    <!-- 合作企业 -->
    <company :companyList="companyList"></company>
    <!-- 名课堂 -->
     <div class="vm-title">
      <div class="animated">
      <p class="vm-title-chines">名课堂</p>
      <div class="vm-title-line"></div>
      <p class="vm-title-english">Famous classroom</p>
      </div>
    </div>
    <course class="bgf5"></course>
    
  </div>
</template>

<script>
import $ from "jquery";

import footerNav from "@/components/Footer.vue";
import banner from "@/components/Banner";
import guarantee from "../Employment/components/guarantee";
import salaryHero from "../Index/components/Salary";
import company from "../Employment/components/company";
import course from "../Index/components/Class";
import audition from "./components/audition";
import characteristic from "./components/characteristic";
import spot from "./components/spot";
import intermediate from "./components/intermediate";
import intermediateOne from "./components/intermediate1";
import socia from "./components/socia";
import javeOne from "./components/javaone";
import navRight from "./components/navRight";
import {
  queryBannerList,
  queryStudentsList,
  queryCompanyList
} from "@/api/index";

export default {
  components: {
  
    banner,
    characteristic,
    guarantee,
    salaryHero,
    company,
    course,
    audition,
    spot,
    intermediate,
    intermediateOne,
    socia,
    javeOne,
    navRight,
      footerNav
  },
  data() {
    return {
      activeT:1,
      bannerList: [],
      salaryHero: [],
      companyList: [],
      city: localStorage.getItem("city")
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let bannerList = await queryBannerList(2, 2);
      this.bannerList = bannerList.data.data;
      let salaryHero = await queryStudentsList(1, 2);
      this.salaryHero = salaryHero.data.data;
      let companyList = await queryCompanyList();
      this.companyList = companyList.data.data;
    },
    handleScroll() {
      //改变元素#searchBar的top值
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollTop > 2900 && scrollTop < 3400) {
        $(".vm-audtion-content  .one").addClass("bounceInLeft");
        $(".vm-audtion-content .four").addClass("bounceInLeft");
        $(".vm-audtion-content .two").addClass("bounceInRight");
        $(".vm-audtion-content .five").addClass("bounceInRight");
      }
    },
  },
  mounted() {
    //给window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/comm.css");

@import url("../../assets/css/title.css");
</style>